export enum PinContentType {
	LETTER = 'letter',
	ICON = 'icon',
}
